import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter, HashRouter } from "react-router-dom";
import { ConfigProvider, Row, Col, Spin, message } from "antd";
// 由于 antd 组件的默认文案是英文，所以需要修改为中文
// import zhCN from 'antd/locale/zh_CN';
// import "antd/dist/reset.css";
import zhCN from 'antd/lib/locale/zh_CN';
import 'antd/dist/antd.less'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import './common.less'
import request from "@/utils/request"; //全局加载方法
import { pageType } from '@/utils/common'; //公共方法组件
import { reactDrawer, reactModal } from '@/components/modal/modal'; //弹窗
// import '@/utils/wxShare'


dayjs.locale('zh-cn');

/* // @ts-ignore  忽略错误 */
// 全局loding
const loading = (
  <Row justify="center" align="middle" style={{ height: "100vh", background: '#00000020' }}>
    <Col>
      <Spin size="large"></Spin>
    </Col>
  </Row>
);


const Home = React.lazy(() => import("@/controller/home/home"));





// 页面rem适配
const changeSize = () => {
  // 如果是手机类型，直接return
  if (/(iPhone|iPad|iPod|iOS|Android|Windows Phone|BlackBerry|SymbianOS)/i.test(navigator.userAgent)) {
    var stdw = 750;
    // var stdh = 1334;
    const baseSize = 100

    var docEl = document.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function () {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        const scale = clientWidth / stdw
        docEl.style.fontSize = 100 * scale + 'px';
        // let size = (baseSize * Math.min(scale, 2)) < 38 ? 38 : (baseSize * Math.min(scale, 2))
        // docEl.style.fontSize = size + 'px';

      };
    if (!document.addEventListener) return;
    recalc();
    window.addEventListener(resizeEvt, recalc, false);
    document.addEventListener('DOMContentLoaded', recalc, false);
    return
  }


  // 设置1rem 等于多少 px
  const baseSize = 100
  // 当前页面宽度和高度相对于 1920x1080的缩放比例，取两者中较小的一个作为缩放比例。
  const scale = document.documentElement.clientWidth / 2560
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  let size = (baseSize * Math.min(scale, 2)) < 42 ? 42 : (baseSize * Math.min(scale, 2))
  // let size = baseSize * Math.min(scale, 2)
  document.documentElement.style.fontSize = size + 'px'
}

window.onresize = changeSize;

// !挂载全局方法
(React as any).$axios = request; //全局axios 方法
(React as any).pageType = pageType(); //当前页面类型 pc addroid ios
(React as any).reactModal = reactModal; //全局请求地址
(React as any).reactDrawer = reactDrawer; //全局请求地址


function App() {

  useEffect(() => {
    changeSize()  //页面rem适配

    message.config({
      top: '30vh' as any,
    })
    return () => {
      //! 组件卸载时将其删除
      (React as any).$axios = undefined;
      (React as any).pageType = undefined;
      (React as any).reactModal = undefined;
      (React as any).reactDrawer = undefined;
    };

  }, []);

  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>  {/* 浏览器的路由模式*/}
        <React.Suspense fallback={loading}>   {/* 因为是懒加载，加载过程中的loding */}
          <Routes>
            <Route path="/*" element={<Home />}></Route>
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </ConfigProvider>

  );
}

export default App;
